
/**客户端版本*/
const client_ver = '5.3.0';
/**是否刷新缓存(0:不刷新;1:刷新)*/
//const refresh_type = 0;
/**普通接口前缀*/
// const intfc_prefix_common = 'http://vapi.people.cn/test/cdrb/appapi';//测试
// const intfc_prefix_common = 'http://vapi.cdrb.com.cn';//正式
// const intfc_prefix_common = 'http://tapi.peopletech.cn/app';//本地测试
// const intfc_prefix_common = 'http://v2api.cdrb.com.cn/app';//预发环境
// const intfc_prefix_common = 'http://10.50.162.192:8092'; //5.0开发环境
// const intfc_prefix_common = 'http://testcdrbappapi.peopletech.cn'; //qa环境
// const intfc_prefix_common = 'http://10.50.161.227:8492';
// const intfc_prefix_common = 'http://testcdrbappapi.peopletech.cn'; //qa环境
// const intfc_prefix_common = 'http://v5api.cdrb.com.cn';
/* 政务接口 */
// const govUrl = 'http://tapi.peopletech.cn/org'
// const govUrl = 'http://v2api.cdrb.com.cn/org' //预发环境
// const govUrl = 'http://10.50.162.192:8094' //5.0开发环境
// const govUrl = 'http://testcdrbjghapi.peopletech.cn' //qa环境
// const govUrl = 'http://v5jghapi.cdrb.com.cn'

/**分享地址前缀*/
// const share_url_prefix = 'http://vweb.people.cn/test/cdrb/wap/';
const share_url_prefix = 'http://vshare.cdrb.com.cn';//正式
/**App下载页地址*/
const app_down_link = 'http://vweb.people.cn/prod/common/api/share/down.php?pjcode=cdrb_2_201503';
/**App打开地址*/
const app_open_link = 'cdrbdailynewsdetail://open?';

const app_bot_link_text = {
	'hasComments': '天下景观在锦观',
	'noComments': '天下景观在锦观'
};

switch(process.env.NODE_ENV){
	case 'development':
		/**普通接口前缀*/
		var intfc_prefix_common = '/intfc_prefix_common' //qa环境
		/* 政务接口 */
		// var govUrl = 'https://testcdrbjghapi.peopletech.cn' //qa环境
			// var govUrl = 'https://testcdrbh5.peopletech.cn' //测试环境
			var govUrl = 'http://10.50.161.227:8494' //开发环境
		break
	case 'testing':
		/**普通接口前缀*/
		var intfc_prefix_common = 'https://testcdrbappapi.peopletech.cn'//qa环境
		/* 政务接口 */
		var govUrl = 'https://testcdrbjghapi.peopletech.cn' //qa环境
		break
	case 'production':
		/**普通接口前缀*/
		var intfc_prefix_common = '';
		/* 政务接口 */
		var govUrl = '/gov'
		break
}


export {
	client_ver,
	//refresh_type,
	intfc_prefix_common,
	share_url_prefix,
	app_down_link,
	app_open_link,
	app_bot_link_text,
  govUrl
};


// WEBPACK FOOTER //
// ./src/constants/project.js